import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ToggleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ToggleSVG;
